export const WIDGET_CARD_SKELETON_ROWS = 5
